export class RequestTimedOutError extends Error {
	get skipLogging() {
		return false
	}

	constructor(message: string) {
		super(message)
		this.name = 'RequestTimedOutError'

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, RequestTimedOutError)
		}
	}
}
